var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector731(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1313,
    height: 458,
    viewBox: "0 0 1313 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1263 0H50C22.3858 0 0 22.3857 0 50V407.526C0 435.14 22.3858 457.526 50 457.526H865.336H981.5H1263C1290.61 457.526 1313 435.14 1313 407.526V50C1313 22.3858 1290.61 0 1263 0Z",
    fill: "url(#paint0_linear_886_2)",
    fillOpacity: 0.55
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_886_2",
    x1: 0,
    y1: 0,
    x2: 1192.79,
    y2: 762.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00666656,
    stopColor: "#006D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516667,
    stopColor: "#4F765A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8720"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector731);
export default __webpack_public_path__ + "static/media/Vector 73 (1).0556681ba8ad75830c01dce78905ed78.svg";
export { ForwardRef as ReactComponent };